import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  desktopCardTitle: 'Contact Details',
  heading: 'Add your details',
  calloutProps: {
    description: 'For security reasons, your messaging service will be disabled for 24 hours upon eSIM activation.'
  },
  buttonProps: {
    leftCta: {
      title: 'REQUEST ORDER VIA OTP'
    },
    onLeftCtaPress: {
      id: ''
    }
  },
  fields: [{
    fieldId: 'mssidn',
    fieldType: 'INPUT',
    fieldData: {
      label: 'Mobile number*',
      placeholder: 'Enter mobile number',
      inputRegex: '^[6-9]{1}[0-9]*$',
      maxLength: 10,
      defaultValue: '8979984355',
      validationRegex: '^\\d{10}$',
      onValidInput: {
        actions: [{
          id: 'onValidInput'
        }]
      },
      onInValidInput: {
        actions: [{
          id: 'onInValidInput'
        }]
      },
      onPressIn: {
        actions: [{
          analyticsAction: 'click',
          analyticsData: {
            subSection: ''
          }
        }]
      },
      onBlur: {
        actions: [{
          analyticsAction: 'click',
          analyticsData: {
            subSection: ''
          }
        }]
      }
    }
  }, {
    fieldId: 'checkbox',
    fieldType: 'CHECKBOX',
    required: true,
    fieldData: {
      direction: 'row',
      onSelectionMeta: {
        actions: [{
          analyticsAction: 'click',
          analyticsData: {
            subSection: ''
          }
        }]
      },
      data: [{
        id: 'TTEM_1',
        label: 'Lorem Ipsum is',
        value: 'ITEM_1'
      }]
    }
  }, {
    fieldId: 'radio',
    fieldType: 'RADIO',
    checkedRadioId: '1',
    fieldData: {
      title: 'Get eSIM for*',
      radioButtons: [{
        id: 'radio1',
        label: 'My device',
        value: 'MY_DEVICE'
      }, {
        id: 'radio2',
        label: 'Other device',
        value: 'OTHER_DEVICE'
      }],
      onSelection: {
        id: 'redio',
        test: 'radio data'
      }
    },
    hideOnPlatform: ['ios-webview', 'android-webview', 'dweb']
  }, {
    fieldId: 'eid',
    fieldType: 'INPUT',
    fieldData: {
      defaultValue: '90909090909090909090909090909090',
      label: 'EID number*',
      placeholder: 'Enter 32 digit EID number',
      maxLength: 32,
      validationRegex: '^\\d{32}$',
      actionCta: {
        title: 'find eid'
      }
    }
  }, {
    fieldId: 'date',
    fieldType: 'DATE',
    fieldData: {
      mode: 'date',
      onInvalidMetaData: {
        actions: [{
          analyticsAction: 'click',
          analyticsData: {
            subSection: ''
          }
        }]
      },
      variant: 'input',
      inputProps: {
        prependItems: {
          prefixIcon: {
            iconName: 'CalendarIcon'
          }
        },
        showPrepend: false,
        appendItems: {
          postfixIcon: {
            iconName: 'CalendarIcon'
          }
        },
        label: 'date of birth',
        showAppend: true
      }
    }
  }],
  showTitleSection: true,
  titleSectionProps: {
    title: 'Create eSIM request',
    withChildrenCardWrapper: true
  }
}, getTestId('FormWidgetContainer'));